import styles from './NewProfit.module.scss'
import { NewProfitProps } from './NewProfit.types'

export const NewProfit = ({ title, text, dark }: NewProfitProps) => {
  return (
    <section className='section'>
      <div
        className={[
          styles.NewProfit,
          dark ? styles[`NewProfit--dark`] : '',
        ].join(' ')}
      >
        <h2>{title}</h2>
        <p>{text}</p>
      </div>
    </section>
  )
}
